var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7627 2.50781H17.3024L11.7539 8.85536L18.2813 17.4929H13.1704L9.16738 12.2543L4.58703 17.4929H2.04581L7.98045 10.7035L1.71875 2.50781H6.95936L10.5777 7.29613L14.7627 2.50781ZM13.8713 15.9714H15.2786L6.19469 3.94946H4.68454L13.8713 15.9714Z",
    fill: "#1E2134"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.0416d0e8a59eb2b3493ce35b5198eddf.svg";
export { ForwardRef as ReactComponent };